import { render } from "./WorldwideUserManagementApp.vue?vue&type=template&id=48b7042d&scoped=true"
import script from "./WorldwideUserManagementApp.vue?vue&type=script&lang=js"
export * from "./WorldwideUserManagementApp.vue?vue&type=script&lang=js"

import "./WorldwideUserManagementApp.vue?vue&type=style&index=0&id=48b7042d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b7042d"]])

export default __exports__